import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

// Expose for E2E tests in non-production environments
if (import.meta.env.VITE_APP_ENV !== 'production') {
  window.__E2E_HISTORY__ = history;
}

export default history;
